import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PropsNews } from '@components/Home/Blocks/NewsBlock/NewsCart/PropsNewsCart';
import { HYDRATE } from 'next-redux-wrapper';
import { TypePropsAkb, TypePropsDisk, TypePropsOil, TypePropsTire } from '@app/Types/Catalog';

export interface KeyValue {
  key: string;
  value: string | number;
}

interface IState {
  actionsList: any[];
  tyres?: TypePropsTire[];
  disks?: TypePropsDisk[];
  akb?: TypePropsAkb[];
  oils?: TypePropsOil[];
  news: PropsNews;
}

const initialState: IState = {
  actionsList: [],
  tyres: [],
  disks: [],
  akb: [],
  oils: [],
  news: null,
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setInitHome: (state, action: PayloadAction<IState>) => {
      state.actionsList = action.payload.actionsList;
      state.tyres = action.payload.tyres;
      state.disks = action.payload.disks;
      state.akb = action.payload.akb;
      state.oils = action.payload.oils;
      state.news = action.payload.news;
    },
    setAkbList: (state, action) => {
      state.akb = action.payload;
    },
    setOilList: (state, action) => {
      state.oils = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.home,
      };
    });
  },
});

export const { setInitHome, setAkbList, setOilList } = homeSlice.actions;

export const homeReducer = homeSlice.reducer;
